module.exports = __webpack_public_path__ + "media/images/builders-res-bed38b106a3108f956c82623d0504399.jpg";